import { useEffect } from 'react';
import { PagePath } from '@monorepo/client-types';
import type { BreadcrumbItem } from '@monorepo/nova-ui';
import { useBreadcrumbs } from '@monorepo/nova-ui';

const DEFAULT_OVERVIEW_BREADCRUMB: BreadcrumbItem = {
  value: 'navigation:breadcrumbs.overview',
  href: PagePath.Overview,
};

export const useBreadcrumbsItems = (
  items: BreadcrumbItem[] | null,
  deps?: Array<unknown>,
) => {
  const { setItems, clearItems } = useBreadcrumbs();

  useEffect(() => {
    if (items && items.length > 0) {
      // Always prepend overview breadcrumb
      const itemsWithOverview = [DEFAULT_OVERVIEW_BREADCRUMB, ...items];
      setItems(itemsWithOverview);
    } else if (items === null) {
      // If null is explicitly passed, clear items
      clearItems();
    } else {
      // If empty array or undefined, just set overview
      setItems([DEFAULT_OVERVIEW_BREADCRUMB]);
    }

    return () => {
      clearItems();
    };
  }, deps ?? []);
};
